<a href="javascript:void(0)" (click)="onLinkClick($event)">{{params.value}}
</a>